import React from 'react';
import { translate } from 'react-i18next';
import { DaysOfWeek, DaysOfWeekKeys } from '../../../Enums/DayOfWeek'
import AdminStepCard from '../../../components/AdminStepCard/AdminStepCard';
import LabeledSelect from '../../../components/LabeledSelect/LabeledSelect';

const SchedulePeriod = ({handleSettingPropChange, isDisabled, setting, ...props}) => {
    const {t: translate} = props;
    const t = (prop) => translate(`workplanManager:settings.schedulePeriod.${prop}`);
    const tCommon = (prop) => translate(`common:dayOfWeek.${prop}`);
    const options = Object.values(DaysOfWeek).map((day) => ({value: day, label: tCommon(DaysOfWeekKeys[day])}))
    const handleSchedulePeriodChange = (value) => handleSettingPropChange('schedulePeriod',{ firstDayOfWeek: value });



    return (
        <AdminStepCard avatar={3} title={t('title')} >
            <LabeledSelect
                options={options}
                value={setting.schedulePeriod.firstDayOfWeek}
                label={t('firstDayOfWeek')}
                handleChange={handleSchedulePeriodChange}
                disabled={isDisabled}
                widthSize="lg"
                searchable={false}
                placeholder={translate(`workplanManager:settings.placeholders.dayOfTheWeek`)}
            />
        </AdminStepCard>
    )
}
export default translate('workplanManager')(SchedulePeriod);